export default {"src":"/_next/static/media/soldier-with-large-green-chat-box.b5b44204.svg","height":369,"width":289};